module.exports = __webpack_public_path__ + "static/media/lunch3.ff08c732.png";